import { render } from "./PaymentPartial.vue?vue&type=template&id=5f5c0ce8"
import script from "./PaymentPartial.vue?vue&type=script&lang=js"
export * from "./PaymentPartial.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__